export default "__VITE_ASSET__D9FcwhAB__"